<template>
<span class="h-full w-full">
  <el-checkbox-group  v-if="modifiable" v-model="checked"  @change="checkChange" >
    <el-checkbox  v-for="label in optionList" :key="label.key" :label="label.key">{{label.label}}</el-checkbox>
  </el-checkbox-group>
 <!-- true-label=1 false-labek=0 -->
  <el-checkbox-group  v-else v-model="checked" disabled>
    <el-checkbox v-for="label in optionList" :key="label.key" :label="label.key" >{{label.label}}</el-checkbox>
  </el-checkbox-group>
</span>
</template>

<script>
import isNil from 'lodash/isNil';
import Editingf from '@/mixins/editingForm';
export default {
  name: 'w-checkgroup-form',
  // optionList = el-checkbox  으로 사용될 배열
  props: ['modifiable', 'target', 'optionList'],
  mixins: [Editingf],
  watch: {
    modifiable: {
      immediate: true,
      deep: true,
      handler: function(val, oldVal) {
        if (val) {
          this.startRadioEdit(this.target, this.checked, this.originalKeys);
        } else if(!isNil(oldVal)){
          // 수정 진행 -> 종료 일경우에만
            this.endRadioEdit(this.editing.value);
        }
      }
    },
    optionList() {
      var checkList = [];
      if (this.optionList.length > 0) {
        this.optionList.forEach(function(li) {
          if (li.value) {
            checkList.push(li.key);
          }
        });
        this.checkedModel = (checkList).slice();
      }
    }
  },
  computed: {
    originalKeys() {
      var originalKeys = [];
      this.optionList.forEach(function(li) {
        originalKeys.push(li.key);
      });
      return originalKeys;
    },
    checked: {
      get: function() {
        return this.checkedModel;
      },
      set: function(list) {
        this.checkedModel = list.slice();
      }
    }
  },
  methods: {
    checkChange(value) {
      this.updateRadioEdit(value);
    }
  },
  data() {
    return {
      checkedModel: []
    };
  }
};
</script>

<style>

</style>



// WEBPACK FOOTER //
// src/components/formeditor/CheckGroupFormEditor.vue